var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="row"> <div id="main-col" class="col-sm-12 col-md-12">  <div class="products-filter clearfix" style="overflow:visible"> <div class="row"> <div class="col-md-12 col-sm-12 col-sm-12"> <h4 class="">'+
((__t=( resources['X100027'] ))==null?'':__t)+
'</h4> </div> </div> <div class="row"> <div class="col-md-12 col-sm-12 col-sm-12"> <div class="form-group"> <label for="searchEventQuery_selectRadius">'+
((__t=( window.resources['X100033'] ))==null?'':__t)+
'</label> <div class="options-box"> <select class="form-control" id="searchEventQuery_selectRadius" style="margin-left:0px;font-size:12px"> <option value="400000000">'+
((__t=(resources['X100034'] ))==null?'':__t)+
'</option> <option value="20000">'+
((__t=(resources['X100035'] ))==null?'':__t)+
'</option> <option value="50000">'+
((__t=(resources['X100036'] ))==null?'':__t)+
'</option> <option value="100000">'+
((__t=(resources['X100037'] ))==null?'':__t)+
'</option> </select> </div> </div> <div class="form-group"> <label for="searchEventQuery_inputAddress">'+
((__t=( window.resources['X100039'] ))==null?'':__t)+
'</label> <input class="typeahead form-control" id="searchEventQuery_inputAddress"> <div class="address-panel"> </div> </div> <div class="form-group"> <label for="searchEventQuery_inputInformation">'+
((__t=( resources['X100040'] ))==null?'':__t)+
'</label> <input class="form-control" id="searchEventQuery_inputInformation" style=""> </div> <div class="form-group"> <label for="searchEventQuery_datepicker">'+
((__t=( resources['X100038'] ))==null?'':__t)+
'</label> <div class="input-daterange input-group col-md-12" id="searchEventQuery_datepicker" style="padding-left:0px;padding-right:0px"> <input class="input-sm form-control" name="start">  </div> </div> </div> </div> <div class="row" style="display:flex"> <div class="col-lg-4 col-md-6" style="padding-top:17px"> <button type="button" style="" class="btn btn-primary col-sm-12" id="searchEventQuery_btnSearch">'+
((__t=( resources['X100031'] ))==null?'':__t)+
'</button> </div> <div class="col-lg-4 col-md-6" style="padding-top:17px"> <button type="button" style="" class="btn btn-secondary col-sm-12" id="searchEventQuery_btnClear">'+
((__t=( resources['X100032'] ))==null?'':__t)+
'</button> </div> </div> </div> </div>  <div id="searchEventListItem"></div> </div>';
}
return __p;
};
